import React from 'react';
import useScrollLock from '../utils/useScrollLock';

/**
 * Full-screen photo preview. Tap anywhere (or the ✕) to close. Used for the
 * Anna's photo on the trip screen and in her profile sheet.
 */
export default function PhotoLightbox({ src, alt = '', onClose, closeLabel = 'Close' }) {
  useScrollLock(Boolean(src));
  if (!src) return null;
  // Stop the click bubbling — this overlay is often rendered inside another
  // modal whose backdrop also closes on click.
  const close = (e) => {
    if (e) e.stopPropagation();
    onClose?.();
  };
  return (
    <div
      className="photo-lightbox"
      role="dialog"
      aria-modal="true"
      onClick={close}
    >
      <img src={src} alt={alt} />
      <button
        type="button"
        className="photo-lightbox-close"
        onClick={close}
        aria-label={closeLabel}
      >
        ✕
      </button>
    </div>
  );
}
